<template>
    <ul class="-mb-1 mt-[20px] flex flex-wrap">
        <li class="pagination__list__item">
            <button
                class="mb-1 mr-1 rounded border px-4 py-3 text-sm leading-4 text-gray-400"
                @click="onClickPreviousPage"
                :disabled="isInFirstPage"
            >
                Föregående
            </button>
        </li>

        <li
            v-for="page in pages"
            class="pagination__list__item"
            :key="page.name"
            :disabled="page.isDisabled"
            :class="{ 'pagination__list__item--active': isPageActive(page.name) }"
            @click="onClickPage(page.name)"
        >
            <button
                class="mb-1 mr-1 rounded border px-4 py-3 text-sm leading-4 hover:bg-white cursor-pointer"
                :class="{ 'bg-[#1d3557] text-white': isPageActive(page.name) }"
            >
                {{ page.name }}
            </button>
        </li>

        <li class="pagination__list__item">
            <button
                class="mb-1 mr-1 rounded border px-4 py-3 text-sm leading-4 text-gray-400"
                @click="onClickNextPage"
                :disabled="isInLastPage"
            >
                Nästa
            </button>
        </li>
    </ul>
</template>

<script>
    import { computed } from 'vue'

    export default {
        props: {
            maxVisibleButtons: {
                type: Number,
                required: false,
                default: 3
            },
            resultTotal: {
                type: Number,
                required: false
            },
            total: {
                type: Number,
                required: false
            },
            totalPages: {
                type: Number,
                required: true
            },
            perPage: {
                type: Number,
                required: true
            },
            currentPage: {
                type: Number,
                required: true
            }
        },
        setup(props, { emit }) {
            const startPage = computed(() => {
                // When on the first page
                if (props.currentPage === 1) {
                    return 1
                }

                // When on the last page
                if (props.currentPage === props.totalPages && props.totalPages > props.maxVisibleButtons) {
                    return props.totalPages - props.maxVisibleButtons
                }

                // When in between
                return props.currentPage - 1
            })

            const pages = computed(() => {
                const range = []

                for (
                    let i = startPage.value;
                    i <= Math.min(startPage.value + props.maxVisibleButtons - 1, props.totalPages);
                    i++
                ) {
                    range.push({
                        name: i,
                        isDisabled: i === props.currentPage
                    })
                }

                return range
            })

            const isInFirstPage = computed(() => props.currentPage === 1)
            const isInLastPage  = computed(() => props.currentPage === props.totalPages)

            const isPageActive = (page) => props.currentPage === page

            const onClickPreviousPage = () => emit('pagechanged', props.currentPage - 1)
            const onClickPage         = (page) => emit('pagechanged', page)
            const onClickNextPage     = () => emit('pagechanged', props.currentPage + 1)

            return {
                pages,
                isInFirstPage,
                isInLastPage,
                isPageActive,
                onClickPreviousPage,
                onClickPage,
                onClickNextPage,
            }
        }
    }
</script>
